import * as React from "react";

export const StepIndicator = (props : { nrOfSteps : number, currentStep : number, selectStep : (step : number) => void})  => {
    return (
        <div className={"step-indicator"}>
            {[...Array(props.nrOfSteps)].map((i,index)=> (
                <div className={"step "  + (props.currentStep === index ? "current" : "")} key={index} onClick={() => props.selectStep?.(index)}>
                    {index+1}
                </div>
            ))}
        </div>
    )
}